"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var AdminProductsController = /** @class */ (function () {
    function AdminProductsController(ProductsModel, FlashService, UserService, ProductCategoriesModel, $window) {
        var _this = this;
        this.$window = $window;
        this.products = [];
        this.user = UserService.getCurrentUser();
        this.loading = true;
        this.ProductsModel = ProductsModel;
        this.FlashService = FlashService;
        this.inDollars = Teller_1.inDollars.bind(this);
        this.options = {
            disabled: [
                { name: "Disabled", value: 1 },
                { name: "Enabled", value: 2 },
            ],
            purchasable: [
                { name: "Shown", value: true },
                { name: "Hidden", value: false },
            ],
            category: [],
            sort: [
                { name: "Name A-Z", type: "name", direction: "asc" },
                { name: "Name Z-A", type: "name", direction: "desc" },
                { name: "SKU A-Z", type: "sku", direction: "asc" },
                { name: "SKU Z-A", type: "sku", direction: "desc" },
                {
                    name: "Date Added (Newest First)",
                    type: "created_at",
                    direction: "desc",
                },
                {
                    name: "Date Added (Oldest First)",
                    type: "created_at",
                    direction: "asc",
                },
                { name: "Price (Low to High)", type: "price", direction: "asc" },
                { name: "Price (High to Low)", type: "price", direction: "desc" },
                {
                    name: "Website Order (Low to High)",
                    type: "sequence",
                    direction: "asc",
                },
                {
                    name: "Website Order (High to Low)",
                    type: "sequence",
                    direction: "desc",
                },
            ],
        };
        this.search = {
            disabled: this.options.disabled[1].value,
        };
        //this.search.disabled = this.options.disabled[1]; //show enabled products only by default
        ProductCategoriesModel.get().then(function (response) {
            _this.options.category = response.categories;
        });
        ProductsModel.get(this.getSearchParams()).then(function (response) {
            _this.products = response.products.data;
            _this.totalItems = response.products.total;
            _this.currentPage = response.products.current_page;
            _this.loading = false;
        });
    }
    AdminProductsController.prototype.toggleProductPurchasable = function (product) {
        var _this = this;
        var data = Object.assign({}, product);
        data.purchasable = !data.purchasable;
        this.ProductsModel.toggleData(data).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        });
    };
    AdminProductsController.prototype.toggleProductDisable = function (product) {
        var _this = this;
        var data = Object.assign({}, product);
        data.disabled = !data.disabled;
        this.ProductsModel.toggleData(data).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        });
    };
    AdminProductsController.prototype.pageChanged = function () {
        var _this = this;
        this.loading = true;
        this.ProductsModel.get(this.getSearchParams(this.currentPage)).then(function (response) {
            _this.loading = false;
            _this.products = response.products.data;
            _this.totalItems = response.products.total;
            _this.currentPage = response.products.current_page;
            _this.loading = false;
        });
    };
    AdminProductsController.prototype.searchProducts = function () {
        var _this = this;
        this.loading = true;
        this.ProductsModel.get(this.getSearchParams())
            .then(function (response) {
            _this.products = response.products.data;
            _this.totalItems = response.products.total;
            _this.currentPage = response.products.current_page;
            _this.loading = false;
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    };
    AdminProductsController.prototype.getSearchParams = function (currentPage, removeNulls) {
        if (currentPage === void 0) { currentPage = 1; }
        if (removeNulls === void 0) { removeNulls = true; }
        var params = {
            nameOrSKU: this.search.nameOrSKU ? this.search.nameOrSKU : null,
            disabled: this.search.disabled === "" ? null : this.search.disabled,
            purchasable: this.search.purchasable ? this.search.purchasable : null,
            category_id: this.search.category ? this.search.category.id : null,
            sort_type: this.search.sort ? this.search.sort.type : null,
            sort_direction: this.search.sort ? this.search.sort.direction : null,
            page: currentPage ? currentPage : null,
        };
        if (removeNulls === true) {
            params = Object.fromEntries(Object.entries(params).filter(function (_a) {
                var _ = _a[0], value = _a[1];
                return value != null;
            }));
        }
        return params;
    };
    AdminProductsController.prototype.deleteProduct = function (product) {
        var _this = this;
        var confirm = this.$window.confirm("Are you sure you want to delete this product?");
        if (confirm === false) {
            return;
        }
        this.ProductsModel.delete(product)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.searchProducts();
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    };
    return AdminProductsController;
}());
AdminProductsController.$inject = [
    "ProductsModel",
    "FlashService",
    "UserService",
    "ProductCategoriesModel",
    "$window",
];
exports.default = AdminProductsController;
